import { memo } from 'react';
import classnames from 'classnames';
import styles from './RewardHighlight.scss';
import { REWARD_COLORS } from '~/constants';

const MASK_ID = 'REWARD_HIGHLIGHT_MASK_ID';

export interface RewardHighlight_Props {
    isVisible: boolean,
    color: REWARD_COLORS,
}

const RewardHighlight = (props: RewardHighlight_Props) => {
    const { isVisible, color } = props;

    const scale = classnames(styles.scale, {
        [styles.scaleActive]: isVisible,
    });

    const highlight = classnames(styles.highlight, {
        [styles[`highlight-${color}`]]: true,
    });

    return (
        <>
            <svg height="0" width="0" viewBox={'0 0 100 100'}>
                <defs>
                    <clipPath id={MASK_ID}>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M100 0H0V100H100V0ZM85.0001 50C85 44.9979 80.0089 39.9955 70.0267 30.0001C60.0134 20.0001 55.0067 15.0001 50.0001 15C44.9934 15 39.9867 20 29.9733 30.0001L29.9709 30.0025C19.9904 39.9963 15 44.9982 15 50.0001C15 55.0018 19.9903 60.0037 29.9709 69.9976L29.9734 70C39.9867 80 44.9934 85 50 85.0001C55.0067 85 60.0134 80 70.0267 70C80.0089 60.0045 85.0001 55.0021 85.0001 50Z"
                            fill="black"
                        />
                    </clipPath>
                </defs>
            </svg>
            <div
                className={styles.wrapper}
                style={{
                    clipPath: `url(#${MASK_ID})`,
                    WebkitClipPath: `url(#${MASK_ID})`,
                }}
            >
                <div className={scale}>
                    <div className={highlight} />
                </div>
            </div>
        </>
    );
};

export default memo(RewardHighlight);
